/**
 * Step7_Household.js
 * Household composition: adults, children, pet.
 * On Next → PATCH /requests/{id}/ with { adults_count, children_count, pet }
 */

import { useState } from 'react';
import { updateDraft } from '../services/propertyRequestService';

const PETS = [
    { value: '',     label: 'بدون حیوان خانگی' },
    { value: 'cat',  label: 'گربه 🐱' },
    { value: 'dog',  label: 'سگ 🐶' },
    { value: 'bird', label: 'پرنده 🐦' },
];

const Counter = ({ label, value, onChange, min = 0, max = 20 }) => (
    <div className="s7-counter">
        <span className="s7-counter-label">{label}</span>
        <div className="s7-counter-ctrl">
            <button type="button" onClick={() => onChange(Math.max(min, value - 1))} disabled={value <= min}>−</button>
            <span className="s7-counter-val">{value}</span>
            <button type="button" onClick={() => onChange(Math.min(max, value + 1))} disabled={value >= max}>+</button>
        </div>
    </div>
);

export default function Step7_Household({ requestId, onNext, onBack, initialData = {} }) {
    const [adults, setAdults]     = useState(initialData.adults_count ?? 1);
    const [children, setChildren] = useState(initialData.children_count ?? 0);
    const [pet, setPet]           = useState(initialData.pet || '');

    const [saving, setSaving] = useState(false);
    const [error, setError]   = useState('');

    const handleNext = async () => {
        setError('');
        setSaving(true);
        try {
            const patch = {
                adults_count: adults,
                children_count: children,
            };
            if (pet) patch.pet = pet;
            await updateDraft(requestId, patch);
            onNext(patch);
        } catch {
            setError('خطا در ذخیره اطلاعات خانوار. لطفاً دوباره تلاش کنید.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <h2 className="prw-step-title">ترکیب خانوار</h2>
            <p className="prw-step-desc">تعداد اعضای خانواده و حیوان خانگی را مشخص کنید.</p>

            <div className="s7-counters">
                <Counter label="بزرگسال" value={adults}   onChange={setAdults}   min={1} />
                <Counter label="کودک"    value={children} onChange={setChildren} min={0} />
            </div>

            <div className="prw-field" style={{ marginTop: 24 }}>
                <label className="prw-label">حیوان خانگی</label>
                <div className="prw-option-grid s7-pet-grid">
                    {PETS.map(p => (
                        <button
                            key={p.value}
                            type="button"
                            className={`prw-option-card ${pet === p.value ? 'selected' : ''}`}
                            onClick={() => setPet(p.value)}
                            aria-pressed={pet === p.value}
                        >
                            {p.label}
                        </button>
                    ))}
                </div>
            </div>

            {error && <p className="prw-error">{error}</p>}

            <div className="prw-nav">
                <button className="prw-btn prw-btn-secondary" onClick={onBack}>→ مرحله قبل</button>
                <button className="prw-btn prw-btn-primary" onClick={handleNext} disabled={saving}>
                    {saving ? 'در حال ذخیره...' : 'مرحله بعد ←'}
                </button>
            </div>
        </div>
    );
}
